import { useSearchParams, useNavigate } from "react-router-dom";
import Container from "../container";
import { MdCheckCircle, MdCancel } from "react-icons/md";
import Button from "../UI/button";
import styles from "./styles.module.scss";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const order = params.get("order");
  const status = params.get("status");

  const success = status === "success";

  return (
    <section className={styles.section}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.body}>
            <div
              className={`${styles.card} ${
                success ? styles.success : styles.error
              }`}
            >
              <div className={styles.icon}>
                {success ? <MdCheckCircle /> : <MdCancel />}
              </div>

              <h1 className={styles.title}>
                {success ? "Оплата прошла успешно" : "Ошибка оплаты"}
              </h1>

              <p className={styles.text}>
                {success
                  ? "Спасибо за покупку! Мы получили оплату."
                  : "Платёж не был завершён. Попробуйте ещё раз или выберите другой способ оплаты."}
              </p>

              <div className={styles.orderBox}>
                <span>Заказ:</span> {order}
              </div>

              <div className={styles.buttons}>
              
                <Button
                  onClick={() => navigate("/")}
                  text="В магазин"
                  full={true}
                />

                {!success && order && (
                  <button
                    onClick={() => navigate(`/success?orderId=${order}`)}
                    className={styles.btnSecondary}
                  >
                    Попробовать снова
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
